import React from 'react'
import "./ITiBizherosection.css"
function TPMS_1() {
  return (
    <>
    <div>
        <div className="toll-hero">
        {/* <img src="product-img/product4.jpg" alt="toll plaza" /> */}
        <video  className="toll-video" autoPlay loop muted playsInline>
          <source src="video/Hero.mp4" type="video/mp4"/>
          {/* "D:\CyberathonProjects\GSun_Tech\project1\public\video\Hero.mp4" */}
        </video>
        <div className="toll-overlay">
          <h1 data-aos="fade-up" className='fw-bold text-center transforming'>Smart Inventory & Billing for Modern Businesses<br></br><span className='ai-color'>Supporting Digital India</span> </h1>
          <p className='gradient-col1'>
 Real-Time Monitoring | 100% Transparency | Fraud Prevention | Smart 
Analytics</p>
        </div>
      </div>
    </div>
    
    </>
  )
}

export default TPMS_1;
